// Header.jsx
import logo from "../../img/vect.svg";
import React from "react";
import { Global } from "../../helpers/Global";

export const Header = () => {
  return (
    <div className="header">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <h1>{Global.appName}</h1>
    </div>
  );
};